import { alpha, Button, Typography, useTheme } from "@mui/material";
import useLocales from "src/hooks/useLocales";

interface Props {
	isEmpty?: boolean;
	type: string;
	isSelected?: boolean;
	onClick: VoidFunction;
}

export default function FilterItemBtn({ isEmpty, type, isSelected, onClick }: Props) {
	const { translate } = useLocales();
	const theme = useTheme();

	return (
		<Button
			color='inherit'
			onClick={onClick}
			size='small'
			sx={{
				mr: 1,
				display: "inline-block",
				paddingX: 1.5,
				minWidth: 0,
				mb: isEmpty ? 0 : 1,
				backgroundColor: alpha(theme.palette.primary.main, isSelected ? 0.16 : 0)
			}}
		>
			<Typography
				color={isSelected ? "primary.light" : "text.primary"}
				fontSize={12}
				variant='subtitle1'
			>
				{translate(`demo.${type}`)}
			</Typography>
		</Button>
	);
}
